import { hearFromCustomer } from "./data";
import CustomerFeedbackCarousel from "./CustomerFeedbackCarousel";
import Title from "../typography/Title";
import Description from "../typography/Description";

const HearFromCustomer = () => {
  const { description, title } = hearFromCustomer;

  return (
    <section
      id="hearFromCustomers"
      className="relative w-full snap-start snap-always bg-gray-950 px-4 pb-10 pt-12 md:px-6 lg:px-8"
    >
      <div className="relative z-10 mx-auto h-full w-full rounded-3xl bg-black px-5">
        <div className="mx-auto flex h-full w-full max-w-screen-lg flex-col items-center justify-center gap-6 py-14 md:rounded-[2rem] lg:rounded-[3rem]">
          <Title as="h2">{title}</Title>
          {/* <Description>{description}</Description> */}
          <div className="slider-container mx-auto mt-4 w-full overflow-hidden pb-14">
            <CustomerFeedbackCarousel />
          </div>
        </div>
      </div>
    </section>
  );
};

export default HearFromCustomer;
